"use client"

import React, { useEffect, useState } from 'react'
import Loader from '@/Components/Loader/Loader';

const HighlightedTab = ({ item, addHorizontalLine = true }) => {
	const [currentHash, setCurrentHash] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [loadingField, setLoadingField] = useState('');

	useEffect(() => {
		if (typeof window !== 'undefined') {
			setCurrentHash(window.location.hash);
			
			const onHashChange = () => {
				setCurrentHash(window.location.hash);
				setIsLoading(false);
				setLoadingField('');
			};
			
			window.addEventListener("hashchange", onHashChange);
			return () => window.removeEventListener("hashchange", onHashChange);
		}
	}, []);

	const handleClick = (e) => {
		// Only show loader if we're navigating to a different section
		if (!window.location.hash.includes(item.field)) {
			e.preventDefault();
			setIsLoading(true);
			setLoadingField(item.field);
			
			// Add a small delay to ensure the loader is visible before navigation
			setTimeout(() => {
				window.location.hash = item.field;
			}, 300);
		}
	};

	if (typeof window === 'undefined') {
		return (
			<a 
				href={`#${item.field}`}
				key={item.field}
				className="text-[14px] font-poppins flex flex-col cursor-pointer font-medium text-[#8E8E8E]"
			>
				{item.label}
			</a>
		);
	}

	const isActive = window.location.hash.includes(item.field);
	const isCurrentlyLoading = isLoading && loadingField === item.field;

	const isBoxedWarning = item.isBoxedWarning;

	return (
		<a
			href={`#${item.field}`}
			key={item.field + window.location.href}
			onClick={handleClick}
			className={`text-[14px] font-poppins flex flex-col cursor-pointer pb-2 ${addHorizontalLine ? "border-b border-borderLightGrey" : ""} font-medium ${isBoxedWarning ? "text-red-600" : isActive ? "text-blue-600" : "text-[#8E8E8E]"}`}
		>
			{isCurrentlyLoading ? (
				<div className="flex items-center gap-2">
					<div className="w-4 h-4"><Loader /></div>
					<span>{item.label}</span>
				</div>
			) : (
				<div className="flex items-center gap-1.5">
					{isBoxedWarning && (
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
							<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
							<line x1="12" y1="9" x2="12" y2="13"/>
							<line x1="12" y1="17" x2="12.01" y2="17"/>
						</svg>
					)}
					<span>{item.label}</span>
				</div>
			)}
		</a>
	);
}

export default HighlightedTab